<template>
    <div
        class="radio-invalid"
        :class="{
            'd-block-options':
                field.label ==
                'What are you looking for in terms of your investment objective?',
        }"
    >
        <!-- :label="field.label" -->
        <b-form-group
            class="kyc-status-radio overwrite-radio"
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': field.isRequired || isRequired,
            }"
        >
            <label
                :class="{
                    'urdu-label': urduLabel,
                }"
                >{{ field.label }}</label
            >
            <!-- <label for=""
                >{{ field.label
                }}<br v-if="field.breakLine"><span v-if="field.urduLabel" class="urdu-label"
                    >({{ field.urduLabel }})</span
                ></label
            > -->
            <b-form-radio-group
                v-model="model"
                v-validate="{
                    required: field.isRequired,
                }"
                :options="urduLabel ? formatOptions() : field.options"
                :name="field._id"
                :disabled="loading || isDisabled"
                :data-vv-name="field.label"
                :class="{
                    'is-invalid': errors.has(field.label),
                }"
                @input="checked"
                @blur="handleBlur"
            ></b-form-radio-group>

            <!-- <p v-if="field.description" class="description-info mb-4">
                <i class="icon-error_outline"></i>{{ field.description }}
            </p> -->
        </b-form-group>
    </div>
</template>

<script>
import TextField from './TextField'

export default {
    // End of Component > inject

    /*
  |--------------------------------------------------------------------------
  | Component > components
  |--------------------------------------------------------------------------
  */
    components: {},
    /*
  |--------------------------------------------------------------------------
  | Component > extends
  |--------------------------------------------------------------------------
  */
    extends: TextField, // End of Component > extends

    /*
  |--------------------------------------------------------------------------
  | Component > inject
  |--------------------------------------------------------------------------
  */
    inject: {
        $validator: '$validator',
    }, // End of Component > components

    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {
        field: {
            type: Object,
            required: true,
        },
        isRequired: {
            type: Boolean,
        },
    }, // End of Component > props

    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {
            textField: 'title',
            valueField: '_id',
            options: [],
            isDisabled: false,
        }
    }, // End of Component > data

    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        urduLabel() {
            if (this.$store.state.registration.form.languageOption == 'urd') {
                return true
            } else {
                return false
            }
        },
    }, // End of Component > methods

    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
    mounted() {
       // if (this.field.dataSegmentId == process.env.VUE_APP_RC_ACCOUNT) {
            if (
                this.field.key == 'pepInfo.declarationPEP1' ||
                this.field.key == 'pepInfo.declarationPEP2' ||
                this.field.key == 'pepInfo.declarationPEP3' ||
                this.field.key == 'pepInfo.declarationPEP4' ||
                this.field.key == 'pepInfo.declarationPEP5' ||
                this.field.key == 'pepInfo.declarationPEP6' ||
                this.field.key == 'pepInfo.declarationPEP7' ||
                this.field.key == 'pepInfo.declarationPEP8' ||
                this.field.key == 'fatcaInfo.isUSCitizen' ||
                this.field.key == 'fatcaInfo.isUSResident' ||
                this.field.key == 'fatcaInfo.greenCardUS' ||
                this.field.key == 'fatcaInfo.CountryResidentOption' ||
                this.field.key == 'fatcaInfo.CountryTaxOption' ||
                this.field.key == 'fatcaInfo.dualNational' ||
                this.field.key == 'fatcaInfo.isUSEntity' ||
                this.field.key == 'fatcaInfo.IsPowerAttorney'
            ) {
                this.field.isRequired = true
                this.isDisabled = false
                let storeVal = this.$store.getters.getField(this.field.key)

                if (!storeVal) {
                    this.$store.commit('updateField', {
                        key: this.field.key,
                        value: 'No',
                    })
                }
            }
            if (
                this.field.key == 'pepInfo.declarationPEP9' ||
                this.field.key == 'pepInfo.declarationPEP10'
            ) {
                this.field.isRequired = true
                this.isDisabled = false
                let storeVal = this.$store.getters.getField(this.field.key)
                if (!storeVal) {
                    this.$store.commit('updateField', {
                        key: this.field.key,
                        value: 'Neither',
                    })
                }
            }
        //}

        if (this.field.key == 'basicInfo.isMinorAccount') {
            let newValue =
                this.$store.state.registration.form.basicInfo.dateOfBirth

            let todayDate = new Date()

            newValue = new Date(newValue)

            let diff = ~~((Date.now(todayDate) - newValue) / 31557600000)

            if (diff < 18) {
                this.field.isRequired = false
                this.isDisabled = true
                this.model = 'Yes'
            } else {
                this.isDisabled = true
                this.field.isRequired = false
                this.model = 'No'
            }
        }
    }, // End of Component > computed

    created() {
        if (this.field.key == 'basicInfo.isMinorAccount') {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.basicInfo
                        .dateOfBirth
                },
                (newValue, oldValue) => {
                    let todayDate = new Date()

                    newValue = new Date(newValue)

                    let diff = ~~(
                        (Date.now(todayDate) - newValue) /
                        31557600000
                    )

                    if (diff < 18) {
                        this.field.isRequired = false
                        this.isDisabled = true
                        this.model = 'Yes'
                    } else {
                        this.isDisabled = true
                        this.field.isRequired = false
                        this.model = 'No'
                    }
                }
            )
        }
    }, // End of Component > created
    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        formatOptions() {
            this.field.options.forEach((element) => {
                // console.log('Element.title', element.title)

                if (element.text) {
                    element.html = element['text']
                    delete element.text
                }
                return element
            })
            return this.field.options
        },
        checked(event) {
            // console.log(this.field.options[])
            let index = this.field.options.findIndex((field) => {
                if (field.value == event) {
                    return true
                }
            })
            // console.log(this.field.options[index]._id)
            if (this.field.scoreLabel) {
                if (this.urduLabel) {
                    this.$emit('change', {
                        optionId: this.field.options[index]._id,
                        parentID: this.field._id,
                        optionTitle: this.field.options[index].urduLabel,
                        parentTitle: this.field.scoreLabel,
                    })
                } else {
                    this.$emit('change', {
                        optionId: this.field.options[index]._id,
                        parentID: this.field._id,
                        optionTitle: this.field.options[index].text,
                        parentTitle: this.field.scoreLabel,
                    })
                }
            }

            /**
             * Updating Temp Customer
             */
            this.$root.$emit('updateTempCustomer')
        },
    }, // End of Component > mounted
}
</script>
